import { type AuthResponseData, setTokens } from "@shapr3d/frontend-lib";

import { remoteConfigReactClient } from "../components/App/App";
import { accountURL } from "../config";
import { trackingAdapter } from "../lib/TrackingAdapter";

export const saveLoggedInUser = ({ refreshToken, accessToken, id }: AuthResponseData) => {
  setTokens(refreshToken, accessToken);
  trackingAdapter.setUserData({ userID: id });
  remoteConfigReactClient?.setIsLoading(true);
};

export const navigateToAuth = ({
  shouldRelogin,
  authHint,
  emailHint,
}: { shouldRelogin?: boolean; authHint?: "signup" | "login"; emailHint?: string } = {}) => {
  const callbackURL = `${window.location.origin}/auth?redirect_url=${encodeURIComponent(window.location.href)}`;
  const authURL = new URL(`${accountURL}/auth/wv?redirect_url=${encodeURIComponent(callbackURL)}`);
  if (authHint) {
    authURL.searchParams.append("auth_hint", authHint);
  }
  const hashParams = new URLSearchParams();
  if (shouldRelogin) {
    hashParams.append("intent", "relogin");
  }
  if (emailHint) {
    hashParams.append("email_hint", emailHint);
  }
  authURL.hash = hashParams.toString();

  window.location.assign(authURL.toString());
};
